<template>
    <div class="error_warp">
        <div class="error_tips">
            <div class="tips_title">!</div>
            <div class="tips_text">
                您没有权限访问该资源
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "error"
    }
</script>

<style lang="scss" scoped>
.error_warp{
    width: 100%;
    height: 100vh;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    .error_tips{
        //width: 300px;
        //height: 200px;
        background: rgba(0,0,0,0.8);
        border-radius: 20px;
        color: #fff;
        padding: 10px 10px 30px;
        box-sizing: border-box;
        .tips_title{
            font-size: 50px;
            text-align: center;
        }
        .tips_text{
            margin-top: 10px;
            font-size: 35px;
        }
    }
}
</style>
